<form *ngIf="formRicerca" class="row" [formGroup]="formRicerca">
    
    <mat-form-field>
        <mat-label>Compagnia</mat-label>
        <compagnia-picker formControlName="compagnia"></compagnia-picker>
      </mat-form-field>

    <mat-form-field>
        <mat-label>
            Codice modello
        </mat-label>
        <buffered-input formControlName="cod_modello"></buffered-input>
    </mat-form-field>
    <mat-form-field>
        <mat-label>
            Nome condizione
        </mat-label>
        <buffered-input formControlName="nome_condizione"></buffered-input>
    </mat-form-field>

    <mat-form-field>
        <mat-label>
            Edizione
        </mat-label>
        <buffered-input formControlName="edizione"></buffered-input>
    </mat-form-field>
</form>